<template>
<v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" :color="getButtonColor()" small>
            {{ action }}
            <v-icon>mdi-pencil</v-icon>
        </v-btn>
    </template>
    <v-card>
        <v-card-title>
            <span class="headline">Consultation Notes</span>
        </v-card-title>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-textarea outlined color="blue" label="Consultation Notes" v-model="o_consultation_notes"></v-textarea>
                </v-row>
                <v-row>
                    <em>
                        <small>
                            NOTE: Evaluate the following SOCIAL DETERMINANTS of HEALTH
                            <ol>
                                <li>Family condition</li>
                                <li>Highest educational attainment</li>
                                <li>Comorbidities (medical/substance)</li>
                                <li>Housing conditions</li>
                                <li>Protective factors</li>
                                <li>Perpetuating factors</li>
                                <li>Other determinants</li>
                            </ol>
                        </small>
                    </em>
                </v-row>
                <v-row class="mt-8">
                    <v-textarea outlined color="blue" label="Action/s Taken" v-model="o_actions_taken"></v-textarea>
                </v-row>
                <v-row>
                    <v-textarea outlined color="blue" label="Recommendation/s" v-model="o_recommendations" placeholder="Indicate continuing care sessions or referral to other service providers here."></v-textarea>
                </v-row>
                <v-row>
                    <v-textarea outlined color="blue" label="Medication / Prescription" v-model="o_medications" placeholder="To be filled by psychiatrist MHP."></v-textarea>
                </v-row>

            </v-container>
            <div class="error-msg" v-if="isElapsed() || submitFailedDueToElapsed"> 
                Cannot update anymore. Consultation Notes could only be updated within 24 hours
            </div>

        </v-card-text>        
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="save" :disabled="disabled">Save</v-btn>
        </v-card-actions>
        <v-snackbar v-model="hasSaved" :timeout="2000" absolute bottom left>
            Notes have been updated
        </v-snackbar>


    </v-card>
</v-dialog>
</template>

<script>
import moment from 'moment'
import store from '../store'
import {
    post_user_note
} from '../api'

export default {
    props: ['id', 'consultation_notes', 'actions_taken', 'recommendations', 'action',
        'medications', 'appointment_date', 'user_id'
    ],
    data() {
        return {
            dialog: false,
            note_id: this.id,
            submitFailedDueToElapsed: false,
            o_consultation_notes: this.consultation_notes,
            o_actions_taken: this.actions_taken,
            o_recommendations: this.recommendations,
            o_medications: this.medications,
            hasSaved: false,
            isEditing: null,
            model: null,
        }
    },
    computed: {
        disabled: function() {
            return this.isElapsed()
        }
    },
    methods: {
        isElapsed: function() {
            const now = new Date()
            const noteDate = new Date(this.appointment_date)
            const hoursElapsed = Math.abs(now - noteDate) / 36e5
            return hoursElapsed >= 24
        },
        format_to_date: function () {
            return moment.utc(this.appointment_date).local().format('ll')
        },
        getButtonColor: function () {
            if (this.action === "Edit") {
                return 'light-blue accent-1'
            }
            return 'green lighten-1'
        },
        save() {
            if (this.isElapsed()) {
                this.submitFailedDueToElapsed = true
                return
            }

            const jwt = store.getters.getJwt
            const data = {
                id: this.note_id || '',
                consultation_notes: this.o_consultation_notes,
                actions_taken: this.o_actions_taken,
                recommendations: this.o_recommendations,
                medications: this.o_medications,
                appointment_date: this.appointment_date,
                user_id: this.user_id
            }
            

            post_user_note(jwt, data).then(response => {
                /* Update Note Id from the saved id*/
                this.note_id = response.data.note_id
                this.dialog = false
            })
            this.isEditing = !this.isEditing
            this.hasSaved = true
        },
    }
}
</script>

<style scoped>
.error-msg {
  color: red;
  font-weight: bold;
}
</style>